import { Component, OnInit } from '@angular/core';
import { Utils } from 'app/components/utils/Utils';
import { OperatorFilterEnum } from 'app/models/filter-model';
import { Logger } from 'app/models/logger-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import * as moment from 'moment';
import {LogMessage as NgxLogMessage} from 'ngx-log-monitor';
import { map, Observable, take, tap, timer } from 'rxjs';

@Component({
  selector: 'app-admin-logger',
  templateUrl: './admin-logger.page.html',
  styleUrls: ['./admin-logger.page.scss'],
})
export class AdminLoggerPage implements OnInit {

  fieldFilters: any[] = [];
  loggers: Logger[] = [];
  restoredLogs: NgxLogMessage[] = [];

  constructor(    
    private restService: RestService,
    private appService: AppService) { }

  ngOnInit() {
    this.fieldFilters.push({
          name: 'logLevel',
          type: 'select',
          multiple: false,
          value: '',
          values: [],
          options: ['DEBUG','ERROR','INFO','VERBOSE','WARN'],
          label: 'Estado'
        });
        this.fieldFilters.push({
          name: 'createdAt',
          type: 'date',
          multiple: false,
          value: '',
          values: [moment().subtract(1, 'M').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
          options: null,
          label: 'Fecha'
        });
        this.fieldFilters.push({
          name: 'uuid',
          type: 'string',
          multiple: false,
          value: '',
          values: [],
          options: null,
          label: 'UUID'
        });
        this.fieldFilters.push({
          name: 'tag',
          type: 'text',
          multiple: false,
          value: '',
          values: [],
          options: null,
          label: 'Tag'
        });
        this.fieldFilters.push({
          name: 'message',
          type: 'text',
          multiple: false,
          value: '',
          values: [],
          options: null,
          label: 'Mensaje'
        });
        
    this.getLoggers();
  }



  getLoggers(){
    let filters = this.mapAsFilters(this.fieldFilters);
    let sort = '&sort=createdAt,desc';
    
    this.restService.getLoggers(filters + sort).pipe(
      map(logs => logs.content),
      tap(console.log),
      map(logs => logs.map((log:Logger) => ({
        timestamp: new Date(log.createdAt).toLocaleString(),
        type: this.mapType(log.logLevel),
        message: log.tag + '-' + log.message
      } as NgxLogMessage ))),
      tap(console.log)
    ).subscribe(data => this.restoredLogs = data);
  }


  /* 
  VERBOSE => SUCCESS
  DEBUG => LOG
  INFO => INFO
  WARN => WARN
  ERROR => ERR

  */
  private mapType(type: 'VERBOSE' | 'DEBUG' | 'INFO' | 'WARN' | 'ERROR'): ('LOG' | 'INFO' | 'WARN' | 'ERR' | 'SUCCESS' | ''){
    switch(type){
      case 'VERBOSE': return 'SUCCESS';
      case 'DEBUG': return 'LOG';
      case 'INFO': return 'INFO';
      case 'WARN': return 'WARN';
      case 'ERROR': return 'ERR';
      default: return '';
    }
  }
  
    mapAsFilters(fieldFilters:any[]){
      let filters = [];
      let map = [];
      map['date'] = OperatorFilterEnum.BETWEEN;
      map['datetime'] = OperatorFilterEnum.BETWEEN;
      map['time'] = OperatorFilterEnum.BETWEEN;
      map['text'] = OperatorFilterEnum.EQUALS;
      map['select'] = OperatorFilterEnum.EQUALS;
      map['number'] = OperatorFilterEnum.EQUALS;
  
      for(let fieldFilter of fieldFilters){
        if((fieldFilter.value != null && fieldFilter.value != '') || (fieldFilter.values != null && fieldFilter.values.length > 0)){
          filters.push({
            field: fieldFilter.name,
            operator: map[fieldFilter.type],
            value: fieldFilter.value,
            values: fieldFilter.values
          }); 
        }
      }
      return Utils.generateFilters(filters);
    }


}